<template>
  <v-dialog persistent max-width="500" v-model="visible" @keydown.esc="close">
    <v-form ref="form">
      <v-card>
        <v-card-title>上传资源</v-card-title>
        <v-card-text>
          <group-selector v-model="keywordRecord.group" :rules="rules.required"/>
          <asin-selector allow-new v-model="keywordRecord.asin" :rules="rules.required"/>
          <market-selector v-model="keywordRecord.marketCode" :rules="rules.required"/>
          <v-text-field type="date" label="记录时间" v-model="keywordRecord.recordDate" :rules="rules.required"/>
          <v-file-input label="关键词排名记录Excel" v-model="keywordRecord.file" :rules="rules.required"/>
        </v-card-text>
        <v-card-actions>
          <v-checkbox label="就试试, 不进去" v-model="keywordRecord.blocked"/>
          <v-spacer/>
          <v-btn text color="primary" :loading="loading" @click="save">上传</v-btn>
          <v-btn text color="grey" @click="close">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import MarketSelector from "@/components/MarketSelector";
import AsinSelector from "@/components/AsinSelector";
import GroupSelector from "@/components/GroupSelector";
export default {
  name: "KeywordUploadDialog",
  components: {GroupSelector, AsinSelector, MarketSelector },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      keywordRecord: {},
      rules: {
        required: [
          v => !!v || "该字段不得为空."
        ]
      }
    }
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let params = new FormData();
        params.append("group", this.keywordRecord.group);
        params.append("asin", this.keywordRecord.asin);
        params.append("marketCode", this.keywordRecord.marketCode);
        params.append("recordDate", this.keywordRecord.recordDate);
        params.append("blocked", this.keywordRecord.blocked);
        params.append("file", this.keywordRecord.file, this.keywordRecord.file.name);

        this.$axios.post("/keyword", params).then(
            response => {
              this.loading = false;
              this.$emit("reload");
              this.$bus.$emit("msg", response.data);
              this.close();
            }
        );
      }
    },
    close() {
      this.$emit("update:visible", false);
    },
    reset() {
      this.keywordRecord = {
        group: "热海科技",
        asin: null,
        marketCode: "US",
        recordDate: null,
        blocked: false,
        file: null
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.reset();
      }
    },
  },
}
</script>

<style scoped>

</style>